import {
  AssigneeRole,
  PeriodicRulesListResponse,
} from '../client/ria-multi-agent-system.schemas'

export const periodicPolicyRulesMock: PeriodicRulesListResponse = {
  total: 2,
  rules: [
    {
      rule_id: 'PERIODIC-5397AB8D',
      category: 'Access Audit',
      title: 'Monthly leavers test',
      description:
        'Conduct the monthly leavers test to verify recently terminated or ended-contract users and ensure accounts have been disabled as required.',
      instructions:
        '1. Obtain the monthly list of terminations from HRM.\n2. Cross-check each terminated/ended-contract employee against Entra accounts and SAP records.\n3. For any enabled accounts for terminated users, initiate disablement tasks with required approvals and document exceptions.\n4. Record findings and remediation actions for audit purposes.',
      schedule: '0 9 1 * *',
      schedule_description: 'On the first day of each month at 9:00 AM',
      assignee_role: AssigneeRole.HRCoordinator,
      assignee_email: null,
      severity: 'high',
      source_policy: 'IT009 - Logical Access Control policy SOM V4.0.pdf',
    },
    {
      rule_id: 'PERIODIC-B0F72D45',
      category: 'Access Audit',
      title: 'Quarterly service account ownership and activity review',
      description:
        'Quarterly review of service accounts including ownership confirmation, permissions review, and activity log analysis for anomalies.',
      instructions:
        '1. Owner documents service account purpose and properties.\n2. Review permissions and reduce to least privilege where possible.\n3. Review activity logs for anomalies and investigate alerts.\n4. Disable any service accounts no longer in use and document actions.',
      schedule: '0 9 1 1,4,7,10 *',
      schedule_description: 'First day of each quarter at 9:00 AM',
      assignee_role: AssigneeRole.ITSecurityManager,
      assignee_email: null,
      severity: 'high',
      source_policy: 'IT009 - Logical Access Control policy SOM V4.0.pdf',
    },
  ],
}
